import { create } from 'zustand'

import { useSidePanelStore } from '#/shared/lib/side-panel'

interface PhonePanelViewState {
  /** Whether the phone panel is showing its dial keypad sub-view. */
  keypadOpen: boolean
  setKeypadOpen: (open: boolean) => void
}

// Lives in `shared` (not the phone-panel widget) so features outside the widget
// — e.g. the header active-call pill's keypad control — can drive the panel's
// sub-view without importing upward across FSD layers.
export const usePhonePanelViewStore = create<PhonePanelViewState>()((set) => ({
  keypadOpen: false,
  setKeypadOpen: (keypadOpen) => set({ keypadOpen }),
}))

/** Open the side panel and jump straight to the dial keypad. */
export function openPhoneKeypad(): void {
  usePhonePanelViewStore.getState().setKeypadOpen(true)
  useSidePanelStore.getState().open()
}
